// 针对不同接口使用不同的比较策略
export function getCompareStrategies(url) {
  const compareStrategies = {
    list: (oldData={}, newData={}) => {
      // 注意区分 list 和 rows 两种命名
      const oldList = oldData?.data?.list || oldData?.data?.rows || [];
      const newList = newData?.data?.list || newData?.data?.rows || [];
      let newResult = null
      // 简单比较长度和内容
      if(oldList.length !== newList.length || JSON.stringify(oldList) !== JSON.stringify(newList)) {
        newResult = JSON.stringify(newData)
      }
      return newResult;
    },
    default: (oldData={}, newData={}) => {
      if(JSON.stringify(oldData?.data||{}) !== JSON.stringify(newData?.data||{})) {
        return JSON.stringify(newData);
      }
      return null;
    }
  }
  switch (url) {
    case 'business/proregister/getNotReceiveByDocPage':
    case 'business/proregister/getAvailableOrdersByPage':
    case 'business/proCheckPrescription/getNotCheckPrescriptionList':
      return compareStrategies.list;
    default:
      return compareStrategies.default;
  }
};

